import React, {useEffect, useState} from 'react';
import {createPortal} from 'react-dom';
import {ReactComponent as CalenderIcon} from '../../assets/icons/calendar.svg';
import DateInput from './Date';
import {DateObject} from 'react-multi-date-picker';
import {parseGregorianDateFilter} from '../../lib/formatJalaliDate';

const ModalDate = ({setState, state = {}}) => {
    const [isOpen, setIsOpen] = useState(false);
    const [fromDateValue, setFromDateValue] = useState(null);
    const [toDateValue, setToDateValue] = useState(null);

    const open = () => setIsOpen(true);
    const close = () => setIsOpen(false);

    useEffect(() => {
        if (!isOpen) {
            return undefined;
        }

        const onKeyDown = (event) => {
            if (event.key === 'Escape') {
                close();
            }
        };

        const previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        window.addEventListener('keydown', onKeyDown);

        return () => {
            document.body.style.overflow = previousOverflow;
            window.removeEventListener('keydown', onKeyDown);
        };
    }, [isOpen]);

    useEffect(() => {
        if (isOpen) {
            setFromDateValue(parseGregorianDateFilter(state.from_date));
            setToDateValue(parseGregorianDateFilter(state.to_date));
        }
    }, [isOpen, state.from_date, state.to_date]);

    const applyFilter = (event) => {
        event.preventDefault();

        const nextState = {};
        if (fromDateValue) {
            nextState.from_date = new DateObject(fromDateValue.toDate()).format('YYYY-MM-DD');
        }
        if (toDateValue) {
            nextState.to_date = new DateObject(toDateValue.toDate()).format('YYYY-MM-DD');
        }

        setState(nextState);
        close();
    };

    const clearFilter = () => {
        setFromDateValue(null);
        setToDateValue(null);
        setState({});
        close();
    };

    return (
        <>
            <button
                type="button"
                className="rest-panel-filter-btn"
                onClick={open}
                aria-label="فیلتر تاریخ تراکنش‌ها"
                aria-expanded={isOpen}
            >
                <CalenderIcon className="fill-gray-500"/>
            </button>

            {isOpen && createPortal(
                <div
                    className="rest-filter-modal"
                    role="dialog"
                    aria-modal="true"
                    aria-label="فیلتر تاریخ"
                >
                    <button
                        type="button"
                        className="rest-filter-modal__backdrop"
                        onClick={close}
                        aria-label="بستن"
                    />

                    <div className="rest-filter-modal__sheet">
                        <div className="rest-filter-modal__accent" aria-hidden="true"/>

                        <form onSubmit={applyFilter} className="rest-filter-modal__form">
                            <h2 className="rest-filter-modal__title">فیلتر بازه زمانی</h2>

                            <div className="rest-filter-modal__fields">
                                <DateInput value={fromDateValue} setValue={setFromDateValue} label="از تاریخ"/>
                                <DateInput value={toDateValue} setValue={setToDateValue} label="تا تاریخ"/>
                            </div>

                            <div className="rest-filter-modal__actions">
                                <button type="submit" className="rest-filter-modal__btn rest-filter-modal__btn--primary">
                                    اعمال فیلتر
                                </button>
                                <button
                                    type="button"
                                    className="rest-filter-modal__btn rest-filter-modal__btn--ghost"
                                    onClick={clearFilter}
                                >
                                    حذف فیلتر
                                </button>
                            </div>
                        </form>
                    </div>
                </div>,
                document.body
            )}
        </>
    );
};

export default ModalDate;
